import api from '~/services/api';

async function obterAnexos(params) {
  const response = await api.post(`ModuloArquivoDigital/arquivos`, params);

  return response.data;
}

export { obterAnexos };
